define(function(require, exports, module) {
    var Config = {
        debug: false,
        lock: false,
        scrollEnd: 0
    };

    Config.serviceInterface = {
        getZyLoadMore: "//jdw.jd.hk/zy/getCateSkuData.do",
        getSearchData: "//jdw.jd.hk/search/list.do",
        getSelfAttr: "//jdw.jd.hk/search/getSelfAttrBySkuId.do",
        getCateBranch: "//jdw.jd.hk/category/getCategoryDataById.do",
        getPrice: "//pm.3.cn/prices/mgets",
        getPcpPrice: "//pm.3.cn/prices/pcpmgets?",
        getTime: "//jdw.jd.hk/getTime.do",
        IndexScrollToLoadMore: "//jdw.jd.hk/getCategoryData.do",
        getSeckillStock: "//jdw.jd.hk/getStockBySkuId.do",
        getGoodsFromConfig: "//jdw.jd.hk/classbaby/getClassBabyDataById.do?",
        searchGoodsByCat: "//jdw.jd.hk/search/list.do",
        searchGoodsByCatJsonp: "//jdw.jd.hk/search/listForJsonp.do",
        getTopManCate: "//jdw.jd.hk/recommend/getData.do",
        getTopManItem: "//jdw.jd.hk/recommend/getSkuInfo.do",
        getReadPv: "//jdw.jd.hk/recommend/getPv.do",
        doGrunt: "//jdw.jd.hk/user/doGrant.do",
        uploadImg: "//jdw.jd.hk/clearance/uploadWaterMarkImg.do",
        getFlagImg: "//jdw.jd.hk/choose/getFlagImgBySkuIds.do",
        getCommentNum: "//jdw.jd.hk/choose/getGoodCount.do",
        getCategorySkus: "//jdw.jd.hk/chooseclz/getCategorySkus.do",
        attentionItem: "//follow-soa.jd.com/rpc/product/follow",
        unAttentionItem: "//follow-soa.jd.com/rpc/product/unfollow",
        isAttentionItems: "//follow-soa.jd.com/rpc/product/batchIsFollow",
        isLogin: "//jdw.jd.hk/lieshou/isLogin.do",
        productFollow: "//jdw.jd.hk/choose/productFollow.do",
        getComponentInfo: "//jicc-web.jd.com/api/component/getComponentInfo/m",
        getComponentInfoWQ: "//jicc-web.jd.com/api/component/getComponentInfo/wq",
        uploadImage: "//jicc-web.jd.com/api/component/uploadImage/m",
        uploadImageWQ: "//jicc-web.jd.com/api/component/uploadImage/wq",
        saveImage: "//jicc-web.jd.com/api/component/save/m",
        saveImageWQ: "//jicc-web.jd.com/api/component/save/wq",
        // checkUploadNameWQ: "//jdw.jd.hk/clearance/checkUploadName.do",
        checkUploadNameWQ: "//global.m.jd.com/clearance/checkUploadName.do",
        checkUploadName: "//global.m.jd.com/clearance/checkUploadName.do",
        newCheckUploadNameWQ: "//jdw.jd.hk/clearance/checkUploadNameNew.do",
        newCheckUploadName: "//global.m.jd.com/clearance/checkUploadNameNew.do"
    };

    Config.validators = {
        idCard: {
            regExp: /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/,
            errorMsg: "请填写正确的18位身份证号码"
        }
    };

    module.exports = Config;
});


// WEBPACK FOOTER //
// ./src/js/Config/Config.js